import { DepartmentType } from '@/types'
import { createFileRoute } from '@tanstack/react-router'

import { CredenzaBody, CredenzaContent } from '@/components/ui/credenza'
import EditDepartmentForm from '@/components/forms/edit-department-form'

export const Route = createFileRoute(
  '/_home/user-role-management/department/edit',
)({
  component: EditDepartmentPage,
})

export default function EditDepartmentPage({
  departmentData,
  setShowEditModal,
}: {
  departmentData: DepartmentType
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <main>
      <CredenzaContent className="flex w-full max-w-2xl justify-center">
        <CredenzaBody>
          <EditDepartmentForm
            departmentData={departmentData}
            setShowEditModal={setShowEditModal}
          />
        </CredenzaBody>
      </CredenzaContent>
    </main>
  )
}
